import React from "react";

export default function ActivitySummary(props){
    return <div>This is the activity summary</div>;
}